import { render } from "./MPromotion.vue?vue&type=template&id=7574cbd8&scoped=true"
import script from "./MPromotion.vue?vue&type=script&lang=js"
export * from "./MPromotion.vue?vue&type=script&lang=js"

import "./MPromotion.vue?vue&type=style&index=0&id=7574cbd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7574cbd8"]])

export default __exports__